import { useEffect, useRef } from 'react'

/**
 * Hook que cierra el menú al presionar la tecla Escape.
 * @param {() => void} onClose - Callback a ejecutar al presionar ESC.
 * @param {boolean} [enabled=true] - Permite desactivar el listener cuando el menú está cerrado.
 */
export function useEscapeKey(onClose, enabled = true) {
  const handlerRef = useRef(onClose)

  useEffect(() => {
    handlerRef.current = onClose
  }, [onClose])

  useEffect(() => {
    if (!enabled) return undefined

    function handleKeyDown(/** @param {KeyboardEvent} event */ event) {
      if (event.key === 'Escape') {
        handlerRef.current()
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [enabled])
}
